export default {
  red: {
    background: 'rgba(251, 0, 71, 0.2)',
    text: '#98002B',
  },
  green: {
    background: 'rgba(15, 251, 39, 0.2)',
    text: '#00940F',
  },
  blue: {
    background: 'rgba(15, 251, 249, 0.2)',
    text: '#006C6C',
  },
  purple: {
    background: 'rgba(190, 0, 190, 0.2)',
    text: '#be41be',
  },
};
